import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "21", y1: "6", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "21", y1: "12", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "21", y1: "18", y2: "18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "3 6 4 7 6 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "3 12 4 13 6 11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "3 18 4 19 6 17", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ListChecks";
const ListChecks = memo(themed(Icon));
export {
  ListChecks
};
//# sourceMappingURL=list-checks.js.map
